import React from "react";
const ArrowTopIcon = () => (
  <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M477.76 1024V186.496L76.032 588.224l-44.544-46.08L509.632 64l481.472 481.6-44.48 44.48-405.248-403.584V1024h-63.616z" />
  </svg>
);
export default ArrowTopIcon;
